<template>
  <div class="student-sri-table mt-7">
    <h6 class="title text-md font-semibold normal-case text-xl">
      {{ $t("smi_sri.latest_tests_of_student", { length: 4 }) }}
    </h6>
    <md-table>
      <md-table-row>
        <md-table-head colspan="3" class="uppercase">
          {{ $t("smi_sri.student_information") }}
        </md-table-head>
        <md-table-head
          colspan="2"
          v-for="(test, testIndex) in getTestList"
          :key="testIndex"
        >
          {{ test }} TEST
        </md-table-head>
      </md-table-row>

      <md-table-row>
        <md-table-head>{{ $t("common.student_code") }}</md-table-head>
        <md-table-head>{{ $t("common.full_name") }}</md-table-head>
        <md-table-head>{{ $t("common.grade") }}</md-table-head>
        <template v-for="test in getTestList">
          <md-table-head :key="test + 'testDate'">{{
            $t("common.date")
          }}</md-table-head>
          <md-table-head :key="test + 'testPer'">Lexile score</md-table-head>
        </template>
      </md-table-row>

      <md-table-row
        v-for="(student, studentIndex) in data"
        :key="studentIndex + 'studentList'"
      >
        <md-table-cell>{{ student.student_code }}</md-table-cell>
        <md-table-cell>{{ student.full_name }}</md-table-cell>
        <md-table-cell>{{ student.grade }}</md-table-cell>
        <template v-for="(test, testIndex) in getSriTest(student)">
          <md-table-cell :key="testIndex + 'studentDate'">{{
            reformatDate(test.date)
          }}</md-table-cell>
          <md-table-cell :key="testIndex + 'studentPer'">{{
            test.lexile_scores
          }}</md-table-cell>
        </template>
      </md-table-row>
    </md-table>
    <yv-pagination
      :pagination="pagination"
      @changePage="changePage"
    ></yv-pagination>
  </div>
</template>
<script>
import { YvPagination } from "@/components/Base";
import { formatDateClient } from "../../../helpers/datetime-helper";
import moment from "moment";

export default {
  name: "student-list-table",
  props: ["data", "pagination", "actionSearch"],
  components: { YvPagination },
  data() {
    return {
      params: {}
    };
  },
  methods: {
    changePage() {
      this.params.page = this.pagination.currentPage;
      this.params.limit = this.pagination.perPage;
      this.actionSearch.action(this.params);
    },

    reformatDate(date) {
      return moment(date).format(`${formatDateClient} HH:mm:00`);
    },

    getSriTest(value) {
      let listSri = [];
      value.sri?.forEach((test, index) => {
        if (index < 4) {
          listSri.push(test);
        }
      });
      return listSri;
    }
  },
  computed: {
    getTestList() {
      return ["1ST", "2ND", "3TH", "4TH"];
    }
  }
};
</script>
<style lang="scss">
.student-sri-table {
  .md-table-head {
    padding: 12px 8px;
    text-align: center;
    background-color: #3e6e98;
    border: 2px solid #ffffff;
    .md-table-head-label {
      color: #ffffff;
      font-weight: 500;
    }
  }
}
</style>
